/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheClasseHoraireRemplacementDefinitiveDto } from './FcbRechercheClasseHoraireRemplacementDefinitiveDto';
import {
    FcbRechercheClasseHoraireRemplacementDefinitiveDtoFromJSON,
    FcbRechercheClasseHoraireRemplacementDefinitiveDtoFromJSONTyped,
    FcbRechercheClasseHoraireRemplacementDefinitiveDtoToJSON,
} from './FcbRechercheClasseHoraireRemplacementDefinitiveDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults
 */
export interface FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheClasseHoraireRemplacementDefinitiveDto>}
     * @memberof FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults
     */
    results?: Array<FcbRechercheClasseHoraireRemplacementDefinitiveDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResultsFromJSON(json: any): FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults {
    return FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheClasseHoraireRemplacementDefinitiveDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResultsToJSON(value?: FcbRechercheClasseHoraireRemplacementDefinitiveDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheClasseHoraireRemplacementDefinitiveDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

